export const TOKEN_PLACEHOLDER = 'YOUR_TOKEN';

export default {
  TOKEN_PLACEHOLDER,
};
